export default "__VITE_ASSET__Cr15z_PU__"